import React, { useEffect, useState, useRef } from 'react'
import { getData } from '../global/Globalapi'
import S_Partner_For from './S_Partner_For';

const Shipping = () => {

    const [data,setData] = useState([]);
    const [modal,setModal] = useState(false);
    const [Existingdata,setExistingdata] = useState(null);

    useEffect(()=>{
        const DataFetch = async()=>{
            const res = await getData('/shipment/shipping-partners');
            console.log(res.data.data);
            setData(res.data.data);
        }

        DataFetch();    
    },[])
  return (
    <div className='mt-[5%]'>
        <div className='ml-auto mr-auto p-8 shadow-2xl rounded-xl bg-white w-fit'>
            <h1 className=' w-full text-center text-3xl font-extrabold'>Shipments Details</h1>
            <button className='ml-[80%] my-4 bg-red-500 text-white font-normal text-center' onClick={()=> setModal(!modal)} >Add a New Parter</button>
    <table className="w-[80%] m-auto border-collapse bg-white/90 rounded-xl shadow-xl overflow-hidden">
  <thead>
    <tr className="bg-red-600 text-center text-white text-lg">
      <th className="px-6 py-3 border border-gray-700">ID</th>
      <th className="px-6 py-3 border border-gray-700">Delivery Partner</th>
      <th className="px-6 py-3 border border-gray-700">Delivery Person</th>
      <th className="px-6 py-3 border border-gray-700">Delivery Partner Phone No</th>
      <th className="px-6 py-3 border border-gray-700">Tracking_URL</th>
      <th className="px-6 py-3 border border-gray-700">Status</th>
      <th className="px-6 py-3 border border-gray-700">Edit</th>
    </tr>
  </thead>

  <tbody className="text-center text-gray-900">
    {data.map((item, i) => (
      <tr
        key={i}
        className="odd:bg-gray-100 even:bg-white hover:bg-gray-200 transition-all"
      >
        <td className="px-6 py-3 border border-gray-300" ><a className='no-underline' onClick={()=>{ setExistingdata({delivery_partner_id:item.delivery_partner_id,delivery_partner_name:item.delivery_partner_name,phone_no:item.phone_no,tracking_id:item.tracking_id,status:item.status}); setModal(!modal)}}>{item.delivery_partner_id}</a></td>
        <td className="px-6 py-3 border border-gray-300">{item.delivery_partner_name}</td>
        <td className="px-6 py-3 border border-gray-300">{item.contact_person_name}</td>
        <td className="px-6 py-3 border border-gray-300">{item.phone_no}</td>
        <td className="px-6 py-3 border border-gray-300">{item.tracking_id}</td>
        <td className="px-6 py-3 border border-gray-300">{item.status}</td>
        <td className="px-6 py-3 border border-gray-300 bg-red-400 text-white" onClick={()=>{ setExistingdata({
          delivery_partner_id:item.delivery_partner_id,
          delivery_partner_name:item.delivery_partner_name,
          contact_person_name:item.contact_person_name,
          phone_no:item.phone_no,
          tracking_id:item.tracking_id,
          status:item.status}); setModal(!modal)}}> Edit</td>
      </tr>
    ))}
  </tbody>
</table>

        </div>
          {modal ? (
            <S_Partner_For closeModal={() => setModal(false)} data={Existingdata}/>
          ) : (
            <></>
          )   }

    </div>
  )
}

export default Shipping
